module.exports = __webpack_public_path__ + "img/xx-icon-kong.04311ab5.svg";